import { useCallback, useEffect, useState } from "react";
import { DEFAULT_TRACK, type ChallengeEligibility, type LeaderRow, type MyChallenge } from "@core/economy/challengeTracks";
import { fetchChallengeBoard, fetchChallengeEligibility, fetchMyChallenge, joinChallenge as joinChallengeApi } from "../data-access/challengeApi";

/** 내 챌린지 진행 + 참가 액션. */
export function useMyChallenge() {
  const [challenge, setChallenge] = useState<MyChallenge | null>(null);
  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(false);
  const [eligibility, setEligibility] = useState<ChallengeEligibility | null>(null);

  const refresh = useCallback(async () => {
    try {
      const next = await fetchMyChallenge();
      // 결말 카드도 재시작 가능 여부가 필요하다. 둘 다 성공한 뒤 상태를 함께 갱신한다.
      const nextEligibility = !next || next.status !== "active" ? await fetchChallengeEligibility() : null;
      setChallenge(next);
      setEligibility(nextEligibility);
      setError(false);
    } catch {
      setError(true); // 이전 진행을 보존하고 조회 실패를 별도로 노출한다.
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // 참가 — 성공 시 진행 즉시 반영
  const join = useCallback(async (track = DEFAULT_TRACK) => {
    const res = await joinChallengeApi(track);
    await refresh();
    return res;
  }, [refresh]);

  return { challenge, loading, error, eligibility, refresh, join };
}

/** 시즌 리더보드(opt-in 랭킹 화면용). */
export function useChallengeLeaderboard(seasonId?: string): { board: LeaderRow[]; loading: boolean } {
  const [board, setBoard] = useState<LeaderRow[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    fetchChallengeBoard(seasonId)
      .then((nextBoard) => { if (alive) setBoard(nextBoard); })
      .catch(() => { /* 랭킹은 best-effort */ })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [seasonId]);
  return { board, loading };
}
